import { colors } from 'crono-fe-common/theme';
import EmailIcon from 'crono-fe-common/icons/Icon-Email';
import LinkedinIcon from 'crono-fe-common/icons/Icon-Linkedin';
import LinkedinIconInMailOnlyCompass from 'crono-fe-common/icons/Icon-Linkedin-Inmail-Only-Compass';
import { IconTodo } from 'crono-fe-common/icons/IconTodo';
import { LinkedinTabLabel } from './linkedinView/index';
import IconVideo from 'crono-fe-common/icons/Icon-Video';
import { CallMdIcon } from '@crono-one/design-system';

export enum TabValue {
  ACCOUNT = 0,
  CONTACTS = 1,
  TIMELINE = 2,
  EMAIL = 3,
  LINKEDIN = 4,
  CALL = 5,
  CALL_LOG = 6,
  OPPORTUNITIES = 7,
  INMAIL = 8,
  GENERIC = 9,
  GENERIC_LOG = 10,
  MEETING = 11,
}

export const getModalTabConfigs = (linkedinTabLabel: LinkedinTabLabel) => ({
  email: {
    label: 'Email',
    tabValue: TabValue.EMAIL,
    renderIcon: (sel: boolean) => (
      <EmailIcon color={sel ? colors.darkGreen : colors.black} />
    ),
  },
  linkedin: {
    label: linkedinTabLabel,
    tabValue: TabValue.LINKEDIN,
    renderIcon: (sel: boolean) => (
      <LinkedinIcon color={sel ? colors.darkGreen : colors.black} />
    ),
  },
  call: {
    label: 'Call',
    tabValue: TabValue.CALL,
    renderIcon: (sel: boolean) => <CallMdIcon />,
  },
  callLog: {
    label: 'Call Log',
    tabValue: TabValue.CALL_LOG,
    renderIcon: (sel: boolean) => <CallMdIcon />,
  },
  inmail: {
    label: 'InMail',
    tabValue: TabValue.INMAIL,
    renderIcon: (sel: boolean) => (
      <LinkedinIconInMailOnlyCompass
        color={sel ? colors.darkGreen : colors.black}
      />
    ),
  },
  generic: {
    label: 'To-do',
    tabValue: TabValue.GENERIC,
    renderIcon: (sel: boolean) => (
      <IconTodo color={sel ? colors.darkGreen : colors.black} />
    ),
  },
  genericLog: {
    label: 'Todo Log',
    tabValue: TabValue.GENERIC_LOG,
    renderIcon: (sel: boolean) => (
      <IconTodo color={sel ? colors.darkGreen : colors.black} />
    ),
  },
  meeting: {
    label: 'Meeting',
    tabValue: TabValue.MEETING,
    renderIcon: (sel: boolean) => {
      return <IconVideo color={sel ? colors.darkGreen : colors.black} />;
    },
  },
});
